import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import styled from "styled-components";
import { DateIconSvg } from "../../styled/AllImages";
import { useTranslation } from "react-i18next";
import "flatpickr/dist/themes/airbnb.css";
// import { createGlobalStyle } from "styled-components";

// export const CustomFlatpickrStyles = createGlobalStyle`
//   .flatpickr-calendar {
//     font-family: inherit;
//   }

//   .flatpickr-months {
//     background-color: var(--themeColor) !important;
//     color: white !important;
//     border-bottom: 1px solid #ccc;
//   }

//   .flatpickr-month {
//     background-color: var(--themeColor) !important;
//   }

//   .flatpickr-current-month {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     color: white !important;
//   }

//
//   .flatpickr-current-month .numInputWrapper {
//     background-color: var(--themeColor) !important;
//     border: none;
//   }

//   .flatpickr-current-month .numInputWrapper input {
//     color: white !important;
//     background: transparent !important;
//     font-weight: 600;
//     border: none;
//   }

//   .flatpickr-weekdays {
//     background-color: var(--themeColor) !important;
//   }

//   .flatpickr-weekday {
//     color: white !important;
//     font-weight: 500;
//     padding: 8px 0;
//     background-color: var(--themeColor) !important;
//   }

//   .flatpickr-prev-month svg,
//   .flatpickr-next-month svg {
//     fill: white !important;
//   }

//
//   .flatpickr-monthDropdown-months {
//     background-color: var(--themeColor) !important;
//   }

//   .flatpickr-monthDropdown-month {
//     color: white !important;
//     font-weight: 500;
//   }

//   .flatpickr-monthDropdown-month:hover {
//     background-color: #004080 !important;
//     color: #ffcc00 !important;
//   }
// `;

const DatePicker = ({
  value,
  onChange,
  weight,
  placeholder = "Select date",
  label = "Date",
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  return (
    <>
      {/* <CustomFlatpickrStyles /> */}
      <DatePickerWrapper>
        <Label weight={weight && weight}>{t(label)}</Label>
        <Flatpickr
          value={value}
          onChange={onChange}
          options={{
            dateFormat: "Y-m-d",
            position: language === "ar" ? "auto right" : "auto left",
          }}
          render={({ defaultValue, value, ...props }, ref) => {
            return (
              <StyledInputWrapper>
                <CalendarIconWrapper lang={language}>
                  <DateIconSvg />
                </CalendarIconWrapper>
                <StyledInput
                  lang={language}
                  {...props}
                  ref={ref}
                  value={value}
                  placeholder={placeholder}
                  readOnly
                />
              </StyledInputWrapper>
            );
          }}
        />
      </DatePickerWrapper>
    </>
  );
};

export default DatePicker;

const DatePickerWrapper = styled.div`
  width: 100%;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  font-weight: ${({ weight }) => (weight ? weight : "")};
  font-size: 17px;
  color: var(--text);
`;

const StyledInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const CalendarIconWrapper = styled.div`
  position: absolute;
  bottom: 20px;
  left: ${({ lang }) => (lang === "en" ? "12px" : "auto")};
  right: ${({ lang }) => (lang === "ar" ? "12px" : "auto")};
  width: 18px;
  height: 18px;
  color: var(--text);
  pointer-events: none;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: ${({ lang }) =>
    lang === "en" ? "10px 12px 10px 40px" : "10px 40px 10px 12px"};
  border: 1px solid var(--border);
  border-radius: 0.375rem;
  background-color: white;
  font-size: 1rem;
  transition: border-color 0.15s ease-in-out;
  color: var(--text);

  &:focus {
    outline: none;
    border-color: var(--themeColor);
    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
  }
`;
